import { usePageableTable } from "../../../context/PageableTableContext";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { PageableTable } from "../../../components/table";
import { Link, useNavigate } from "react-router-dom";
import { DateTimeFormat } from "libraries/date-time-format/date-time-format";
import { PageableTableActions } from "../../../states/pageable-table";
import { Predicates } from "../../../libraries/predicates/predicates";
import { ArtworkApprovalActions } from "../state/approvals";
import { useArtworkApprovalContextStore } from "../context/approvals/ArtworkApprovalsContext";
import { ArtworkApprovalRequestTypes } from "../state/approvals/data.type";
import ArtworkPictureModal from "./ArtworkPicutureModal";
import { PrintingTechniqueActions } from "../state/printingTechnique/create";
import { CreatePrintingTechniqueTypes } from "../state/printingTechnique/create/data";
import ReactModal from "react-modal";

const ArtworkApprovalRequestsIdCellRenderer = memo(
  (model: { id: number | string }) => {
    return (
      <div className="d-flex">
        <span className="pe-2 flex-fill align-self-center">{model.id}</span>
        <div></div>
      </div>
    );
  },
);


export const TableArtworkCollectionSearch = () => {
  const navigate = useNavigate();

  const {state, dispatch:collectionDispatch } = useArtworkApprovalContextStore();
  const {collectionSearchResults:collections, collectionSearchResultsIsLoading:isLoading} = state

  const gridRef = useRef<AgGridReact<Array<any>>>(null);

  const {
    dispatch: dispatchPageTable,
    state: { offset },
  } = usePageableTable();
  const { dispatch } = useArtworkApprovalContextStore();

  useEffect(() => {
    dispatchPageTable(PageableTableActions.setLoading(isLoading));
    if (Predicates.isNotNullAndNotUndefined(collections)) {
      dispatchPageTable(PageableTableActions.setTotal(collections?.count));
    }
  }, [collections, dispatchPageTable, isLoading]);

  useEffect(() => {
    dispatch(
      ArtworkApprovalActions.setStateValue(
        ArtworkApprovalRequestTypes.SET_COLLECTION_SEARCH_RESULTS,
        { ...state.collectionSearchResults, offset: offset },
      ),
    );
  }, [offset]);

  const [showPictureModal, setShowPictureModal] = useState<boolean>(false);
  const [imageToModal, setImageToModal] = useState<any>({
    imageName: null,
    image_file: null,
  });


  const columnDefs = useMemo<ColDef[]>(
    () => [
      {
        headerName: "Code / Name",
        field: "id",
        minWidth: 70,
        cellRenderer: (params: any) => {
          return (
            <>
              <ArtworkApprovalRequestsIdCellRenderer
                id={`${params?.data?.code} - ${params?.data?.name}`}
              />
            </>
          );
        },
      },
      {
        headerName: "Licensor",
        field: "licensor",
        minWidth: 70,
        maxWidth: 340,
        cellRenderer: (params: any) => {
          return (
            <>
              <ArtworkApprovalRequestsIdCellRenderer
                id={
                  params?.data?.licensor?.name &&
                  `${params?.data?.licensor?.name}`
                }
              />
            </>
          );
        },
      },
      {
        headerName: "License",
        field: "user_name",
        minWidth: 70,
        maxWidth: 340,
        cellRenderer: (params: any) => {
          return (
            <>
              <ArtworkApprovalRequestsIdCellRenderer
                id={
                  params?.data?.licensed_property?.name &&
                  `${params?.data?.licensed_property?.name}`
                }
              />
            </>
          );
        },
      },
      {
        headerName: "Requesting Market",
        field: "requestor_location",
        minWidth: 70,
        maxWidth: 340,
        cellRenderer: (params: any) => {
          return (
            <>
              <ArtworkApprovalRequestsIdCellRenderer
                id={
                  params?.data?.requesting_market?.id &&
                  `${params?.data?.requesting_market?.short_name} - ${params?.data?.requesting_market?.full_name}`
                }
              />
            </>
          );
        },
      },
      {
        headerName: "Launch Date",
        field: "data.status",
        minWidth: 70,
        maxWidth: 340,
        cellRenderer: (params: any) => {
          const launchDate = params?.data?.launch_date;

          return (
            <>
              {(params?.data?.status.name === "APPROVED" ||
                params?.data?.status.name === "REJECTED") &&
              !!launchDate
                ? DateTimeFormat.formatTimestamp(launchDate)
                    .toString()
                    .split(" ")[0]
                : ""}
            </>
          );
        },
      },
      {
        headerName: "Actions",
        minWidth: 120,
        maxWidth: 150,
        cellRenderer: (params: any) => {
          return (
            <>
              <Link
                className="mt-1 me-3"
                to={`/artwork/collections/detail/${params.data.id}`}
                style={{ textDecoration: "underline" }}
                state={params.data}
              >
                View
              </Link>

              {!!params.data?.image?.image_base64 &&
              <Link
                className="mt-1 me-3"
                to={""}
                onClick={() => {
                  setImageToModal({
                    imageName: `Collection ${params.data?.name ?? ""}`,
                    image_file: null,
                    image_base64: `data:image/jpeg;base64,${params.data?.image?.image_base64}`,
                    isBlocked: true,
                  });
                  setShowPictureModal(true);
                }}
              >
                Artwork
              </Link>
              }
            </>
          );
        },
      },
    ],
    [collections],
  );

  const defaultColDef = useMemo<ColDef>(
    () => ({
      headerClass: "text-wrap",
      minWidth: 100,
      flex: 1,
      wrapHeaderText: true,
      autoHeaderHeight: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
      suppressMovable: true,
      sortable: true,
    }),
    [],
  );

  const tableProp = useMemo(
    () => ({
      gridRef,
      rowData: collections?.results || [],
      columnDefs,
      defaultColDef,
    }),
    [gridRef, collections, columnDefs, defaultColDef],
  );

  return (
    <>
      <PageableTable tableProp={{ ...tableProp }} />

      <ReactModal
        isOpen={showPictureModal}
        className="custom-modal mold-comps"
        overlayClassName="custom-overlay"
      >
        <ArtworkPictureModal
          handleCloseModal={() => setShowPictureModal(false)}
          product={imageToModal}
          setImage={() => {}}
        />
      </ReactModal>
    </>
  );
};
